import { render, staticRenderFns } from "./Subdomain.vue?vue&type=template&id=10057d96&scoped=true&"
import script from "./Subdomain.vue?vue&type=script&lang=js&"
export * from "./Subdomain.vue?vue&type=script&lang=js&"
import style0 from "./Subdomain.vue?vue&type=style&index=0&id=10057d96&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10057d96",
  null
  
)

export default component.exports